import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=494743c2"
import script from "./project-card.ts?vue&type=script&lang=ts&external"
export * from "./project-card.ts?vue&type=script&lang=ts&external"
import style0 from "./project-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports